import React from 'react'

import { Header, Card, Grid, GridContainer, Row, Heading, Text } from '@plurall/elo-beta'
import MainMenu from 'App/components/MainMenu/MainMenu'

import styles from './Privacy.module.scss'

const Privacy = () => {
  return (
    <>
      <Header description='Proteger seus dados e colocar você no controle é nosso compromisso'>
        Privacidade
      </Header>
      <GridContainer>
        <Row>
          <MainMenu />
          <Grid desktop={8} mobile={12}>
            <Card>
              <div className={styles.card}>
                <div className={styles.heading}>
                  <Heading noParagraph element='h5'>
                    Informações
                  </Heading>
                </div>
                <div className={styles['terms-link']}>
                  <Text
                    dataTestId='terms-link'
                    icon='External-link-small'
                    element='a'
                    href={`${process.env.REACT_APP_PLURALL_HOME}/termos-de-uso`}
                    target='_blank'
                  >
                    Termos de uso
                  </Text>
                </div>
                <Text
                  dataTestId='privacy-policy-link'
                  icon='External-link-small'
                  element='a'
                  href='https://www.canaldatransparencia.com.br/cogna'
                  target='_blank'
                >
                  Portal de Privacidade
                </Text>
              </div>
            </Card>
          </Grid>
        </Row>
      </GridContainer>
    </>
  )
}

export default Privacy
